export const IDS = {

    pnpComplianceReportGrid: 'pnpComplianceReportGrid',
   
    // settings categories states :
    app_policies_settings_compliance_report: 'app.policies.settings.compliance_report',
    app_policies_settings_compliance_report_listing: 'app.policies.settings.compliance_report.listing'
};